import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLynkName = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 26,
	viewBox: "0 0 72 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.3679 21.1991C15.8357 24.0505 12.7504 26 9.19769 26C4.12103 26 0.000152588 22.02 0.000152588 17.1178V0C0.000152588 0 0.240552 0.0522109 0.368654 0.0522109H5.79468V16.2134C5.79468 18.0279 7.31942 19.5002 9.19769 19.5002C10.7499 19.5002 12.06 18.4945 12.4684 17.1218C13.6405 18.9082 15.3457 20.338 17.3679 21.1991Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M51.3759 25.9992V8.8822C51.3759 3.98004 47.2542 0 42.1775 0C37.1009 0 32.98 3.98004 32.98 8.8822V25.9992C33.0964 25.9638 33.2204 25.9478 33.3485 25.9478H38.7753V9.78664C38.7753 7.97293 40.3001 6.5006 42.1775 6.5006C44.0558 6.5006 45.5805 7.97293 45.5805 9.78664V25.9478H51.0065C51.1346 25.9478 51.2586 25.9638 51.3759 25.9992Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.9181 19.848C15.2556 18.6777 12.6095 15.3418 12.6095 11.414V0C12.726 0.0361457 12.8508 0.0522101 12.9772 0.0522101H18.4041V10.5096C18.4041 12.3233 19.9296 13.7956 21.8071 13.7956C23.6845 13.7956 25.2092 12.3233 25.2092 10.5096V0.0522101H30.6361C30.7634 0.0522101 30.889 0.0361457 31.0046 0V11.414C31.0046 15.3418 28.3594 18.6777 24.6952 19.848V25.7711C24.6952 25.8972 24.5887 25.9992 24.4581 25.9992H19.1552C19.0246 25.9992 18.9181 25.8972 18.9181 25.7711V19.848Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M53.6042 25.9526V0C53.7207 0.0361457 53.8446 0.0522109 53.9719 0.0522109H59.3987V6.95524C59.3987 8.76815 60.9235 10.2405 62.8018 10.2405C64.6792 10.2405 66.2039 8.76815 66.2039 6.95524V0.0522109H71.6308C71.7589 0.0522109 71.8828 0.0361457 72.0001 0V6.82993C72.0001 9.21475 71.0244 11.3795 69.4398 12.9763C71.0244 14.5731 72.0001 16.7387 72.0001 19.1219V25.9526C71.8828 25.9165 71.7589 25.9012 71.6308 25.9012H66.2039V18.999C66.2039 17.1845 64.6792 15.7121 62.8018 15.7121C60.9235 15.7121 59.3987 17.1845 59.3987 18.999V25.9012H53.9719C53.8446 25.9012 53.7207 25.9165 53.6042 25.9526Z",
			fill: "currentColor"
		})
	]
});
export default SvgLynkName;
